import { ref, computed } from 'vue-demi';
import { get } from '@teamwork/fetcher';

export default () => {
  const account = ref(null);

  async function fetchAccount() {
    const { data } = await get('account.json');
    if (data.STATUS === 'OK') {
      account.value = data.account;
    }
  }

  const currency = computed(() =>
    account.value.currency
      ? {
          ...account.value.currency,
          decimalPoints: parseInt(account.value.currency.decimalPoints, 10),
          id: parseInt(account.value.currency.id, 10),
        }
      : {},
  );

  const pricePlan = computed(() => {
    if (account.value?.priceplanTrialData) {
      const trialData = account.value.priceplanTrialData;
      const endDate = new Date(trialData.endDate);
      if (Date.now() < endDate) {
        return trialData;
      }
    }

    return account.value?.priceplanData ?? {};
  });

  fetchAccount();
  return {
    account,
    currency,
    pricePlan,
  };
};
